import React, { Component } from 'react';
import PropTypes from 'prop-types';
import localizedStrings from './localization.js';
import SimpleField from './SimpleField';

class PasswordCreator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validator: {
                passLength: true,
                upper: true,
                lower: true,
                number: true,
                special: true,
                passEquals: true
            },
            passerror: false,
        };

    }

    onPasswordInputChange = ({ name, value }) => {
        let passwords = {
            password1: this.props.fields.password1,
            password2: this.props.fields.password2
        };
        passwords[name] = value;

        let validator = this.validatePass(passwords.password1, passwords.password2);
        let error = false;
        if (validator.passEquals || validator.lower || validator.upper || validator.number || validator.special || validator.passLength) {
            error = true;
        }

        this.props.onPasswordInputChange(name, value, error);
        this.setState({ validator: validator, passerror: error });
    }

    validatePass = (value1, value2) => {
        const validator = this.state.validator;

        const lower = (/[a-z]/.test(value1));
        const upper = (/[A-Z]/.test(value1));
        const number = (/[0-9]/.test(value1));
        const specialChar = (/[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`]/.test(value1));
        const numchars = (value1.length >= 8);

        validator.lower = !lower;
        validator.upper = !upper;
        validator.number = !number;
        validator.special = !specialChar;
        validator.passLength = !numchars;
        if (value1 !== '' && value1 === value2) {
            validator.passEquals = false;
        } else {
            validator.passEquals = true;
        }

        return validator;
    }

    validateField = (val) => {
        return val === undefined || val === '';
    }

    render() {
        const { passEquals, passLength, upper, lower, number, special, } = this.state.validator;

        return (
            <div>
                <SimpleField
                    placeholder={localizedStrings.passwordPlaceholder}
                    name='password1'
                    inputType="password"
                    value={this.props.fields.password1}
                    onChange={this.onPasswordInputChange}
                    error={this.state.passerror}
                    validate={this.validateField}
                    autoComplete={'new-password'}
                />
                <SimpleField
                    placeholder={localizedStrings.passwordRepeatPlaceholder}
                    name='password2'
                    inputType="password"
                    value={this.props.fields.password2}
                    onChange={this.onPasswordInputChange}
                    validate={this.validateField}
                    error={this.state.passerror}
                    autoComplete={'new-password'}
                />
                <div style={{
                    textAlign: 'left',
                    borderRadius: '3px',
                    marginTop: '8px',
                    border: '1px solid rgba(34,36,38,.22)',
                    fontSize: '12px',
                }}>
                    <ul>
                        <div><ValidatorIcon error={passEquals} />{localizedStrings.passwordSettingsRuleEqual}</div>
                        <div><ValidatorIcon error={passLength} />{localizedStrings.passwordSettingsRuleMinimumLength}</div>
                        <div><ValidatorIcon error={upper} />{localizedStrings.passwordSettingsRuleUpperCase}</div>
                        <div><ValidatorIcon error={lower} />{localizedStrings.passwordSettingsRuleLowerCase}</div>
                        <div><ValidatorIcon error={number} />{localizedStrings.passwordSettingsRuleNumber}</div>
                        <div><ValidatorIcon error={special} />{localizedStrings.passwordSettingsRuleEspecialChar}</div>
                    </ul>
                </div>
            </div>

        );
    }
}
PasswordCreator.propTypes = {
    fields: PropTypes.object.isRequired,
    onPasswordInputChange: PropTypes.func.isRequired,
};

const ValidatorIcon = (props) => {
    return (
        <div style={{
            display: 'inline-block',
            backgroundColor: props.error ? '#f00' : '#7ed321',
            width: '8px',
            height: '8px',
            borderRadius: '100%',
            marginRight: '5px'
        }} />
    );
};
ValidatorIcon.propTypes = {
    error: PropTypes.bool.isRequired
};

export default PasswordCreator;